export class AnalyzerInfo {
    Id: number;
    Name: string;
}
